/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useMemo, useRef } from 'react';
import { useAppSelector } from 'store/hooks';

/* @ts-ignore */
import TransakSDK from '@transak/transak-sdk';

import { chainIdToMainNetworkName } from 'lib/network';
import { useRouter } from 'next/router';
import { ChainId } from 'types/network';

const useTransak = () => {
  const { account, chainId } = useAppSelector(({ wallet }) => wallet);
  const router = useRouter();
  const transak = useRef();

  const nativeCurrencyName = useMemo(
    () => ({
      1: 'eth',
      11155111: 'eth',
      137: 'matic',
      80002: 'matic',
      devnet: 'sol',
      'mainnet-beta': 'sol',
      1001: 'klay',
      8217: 'klay',
    }),
    [],
  );

  const handleOpenTransak = () => {
    if (!account || !chainId) {
      return;
    }

    const settings = {
      apiKey: process.env.NEXT_PUBLIC_TRANSAK_API_KEY,
      environment:
        process.env.NEXT_PUBLIC_ENV === 'development'
          ? 'STAGING'
          : 'PRODUCTION',
      defaultCryptoCurrency:
        nativeCurrencyName[(chainId as ChainId) || 137].toUpperCase(),
      themeColor: '000000',
      hostURL: window.location.origin,
      networks: chainIdToMainNetworkName[chainId || 137],
      disableWalletAddressForm: true,
      widgetHeight: '600px',
    };

    const transakInstance = new TransakSDK({
      ...settings,
      walletAddress: account,
    });

    transak.current = transakInstance;

    transakInstance.init();
    // This will trigger when the user closed the widget
    transakInstance.on(transakInstance.EVENTS.TRANSAK_WIDGET_CLOSE, () => {
      transakInstance.close();
    });

    // This will trigger when the user marks payment is made.
    transakInstance.on(transakInstance.EVENTS.TRANSAK_ORDER_SUCCESSFUL, () => {
      transakInstance.close();
    });
  };

  useEffect(() => {
    router.events.on('routeChangeStart', () => {
      if (transak.current) {
        const htmlElement = document.querySelector('html');
        if (htmlElement) {
          htmlElement.style.overflow = 'scroll';
        }
        /* @ts-ignore */
        transak.current.close();
      }
    });
  }, [router]);

  return { handleOpenTransak };
};

export default useTransak;
